import React, { ReactElement, useState, useEffect } from 'react';
import { formateDatePile, getLoginInfoPromise} from '../../../../utils/common';
import { useHistory } from 'react-router-dom';
import { getHomechargeOrders } from '../../../../api/filling-pile';
import './index.less';
import emptyStatus from '@assets/emptyStatus.png';
const SelectServiceOrder = (): ReactElement => {
  const [orderList, setOrderList] = useState<any>();
  const [emptyShow, setEmptyShow] = useState<boolean>(false);
  const router = useHistory();
  //根据订单状态显示判断字体颜色

  //判断家充桩的来源
  const judgeSource = item => {
    if (item.createSource === 0) {
      return `家充桩`;
    }
    if (item.createSource === 1) {
      return `随二手车购买的家桩`;
    }
    if (item.createSource === 2) {
      return `随车购买的家桩`;
    }
    if (item.createSource === 3) {
      return `商城购买的家桩`;
    }
  };
  const setTitle = () => {
    document.title='选择服务单'
  }
  const showDate = (time)=>{
    const res = formateDatePile(time).split(' ')[0];
    return res;
  };
 const gotoPage = (e, item) => {
    console.log(item.orderStatusStr)
   console.log(item.orderNo, item)
    window.location.href = item.url;
      /* router.push({
        pathname: '/apply-to-install',
        search: '?orderNo=' + (item.orderNo ? item.orderNo : '')
      });
      if (item.orderStatus === '00' || item.orderStatus === '01') {
        router.push({
          pathname: '/apply-to-install',
          search: '?orderNo=' + (item.orderNo ? item.orderNo : '')
        });
      } else {
        router.push({
          pathname: '/pile-installation',
          search: '?orderNo=' + (item.orderNo ? item.orderNo : '')
        });
      } */
  };
  useEffect(() => {
    console.log(router)
    setTitle();
    getLoginInfoPromise().then(res => {
      getHomechargeOrders({ uid: res.uid, type:1 }).then(list=>{
        console.log(list.data)
        setOrderList(list.data);
        if(list.data.length===0){
          setEmptyShow(true)
        }
      })
    })
      .catch(err => {
        setEmptyShow(true)
      })
  }, []);
  return (
    <div className="installed-box">
      <div className="content">
          <div className="title">你有{orderList && orderList.length}个待安装的家充桩</div>
          {orderList && orderList.map((item,index)=>(
            <div className="order-item" key={index}>
              <div className="order-status">
                <div className="text">{judgeSource(item)}</div>
                <div className="status">{item.orderStatusStr}</div>
              </div>
              <div className="time">购买时间：{showDate(item.createTime)}</div>
              <div className="btn">
                <button onClick={(e) => gotoPage(e, item)}
                  className={(item.orderStatus === '00' || item.orderStatus === '01') ? 'pre-btn' : ''}
                >
                  {(item.orderStatus === '00' || item.orderStatus === '01') ? '预约报装' : '查看详情'}
                </button>
              </div>
            </div>
          ))}

        </div>
      {emptyShow && (
        <div className="empty">
          <img src={emptyStatus} alt="" />
          <div className="title">暂无内容</div>
        </div>
      )}
    </div>
  )
};
export default SelectServiceOrder;
